import { useApiInspectionsV1CompaniesRetrieve } from 'api';
import { Box, Grid, Typography } from 'ui';

export const CompanyInspectorsList = ({ companyId }: { companyId: number }) => {
  const { data } = useApiInspectionsV1CompaniesRetrieve(companyId);
  // const { data } = useOne<InspectionCompany>({
  //   dataProviderName: 'inspections',
  //   id: companyId,
  //   resource: `/v1/companies`,
  // });

  if (!data || !data.inspectors.length) {
    return <Typography variant="subtitle2">No inspectors</Typography>;
  }

  return (
    <>
      {data.inspectors.map((inspector) => (
        <Box
          key={`${inspector.id}-${inspector.name}`}
          sx={(theme) => {
            return {
              border: `1px solid ${theme.palette.border.main}`,
              borderRadius: theme.spacing(1),
              mb: 1,
              padding: theme.spacing(1),
            };
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Typography variant="subtitle1">{inspector.name}</Typography>
              <Typography variant="subtitle2">{inspector.email}</Typography>
              <Typography variant="subtitle2">{inspector.phone_number}</Typography>
            </Grid>
            <Grid item xs={4} sx={{ alignItems: 'center', display: 'flex' }}>
              <Typography variant="subtitle2">{inspector.is_active ? 'Active' : 'Inactive'}</Typography>
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
};
